import Typography from '@mui/material/Typography'
import Heading from '~/client/components/Heading'

export default function Page() {
  return <div>
    {['major', 'main', 'minor', 'sub'].map(variant =>
      <Heading variant={variant}>{`This is a ${variant} <Heading/>`}</Heading>
    )}
    {Array(6).fill().map((_, i) =>
      <Typography sx={{my: 1}} variant={`h${i+1}`}>{`This is an h${i+1}`}</Typography>
    )}
    <Typography sx={{my: 1}} variant="body1">This is variant body1. {loremIpsum}</Typography>
    <Typography sx={{my: 1}} variant="body2">This is variant body2. {loremIpsum}</Typography>
  </div>
}

const loremIpsum = `
Irure labore et commodo adipisicing. Aliqua excepteur aliqua velit tempor do ullamco id commodo exercitation ut ipsum id enim. Pariatur labore Lorem ea eu est fugiat laborum commodo sunt esse ex magna. Eu enim voluptate esse irure reprehenderit mollit tempor fugiat anim. Nulla proident cillum deserunt magna veniam veniam labore tempor irure. Sunt dolore tempor nulla do enim consectetur in ea sunt. Aliqua nostrud occaecat laboris ipsum ullamco velit dolore.
`.trim()
